import {DashboardTileId} from '../types/DashboardTileId';

// A Map, not a record: stored ids arrive unvalidated and `__proto__` would resolve to an inherited value.
export const DASHBOARD_TILE_ID_ALIASES = new Map<string, DashboardTileId>();
